import { render } from "./ListFormsPublic.vue?vue&type=template&id=2b047b8d"
import script from "./ListFormsPublic.vue?vue&type=script&lang=js"
export * from "./ListFormsPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__